module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/table/table.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/table/table.png
// module id = 635
// module chunks = 0